import { ImagesService } from '@shared/images/ImagesService';
import { getFilenameWithVersion } from '@shared/utils/utils';
import React from 'react';
import './ImageListMapCluster.scss';


interface ImageListMapClusterProps {
    images: IImage[];
    onOpen: (image: IImage) => void;
    onEdit?: (image: IImage) => void;
}

export const ImageListMapCluster: React.FC<ImageListMapClusterProps> = ({ images, onOpen, onEdit }) => {
    const handleMouseClick = (e: React.MouseEvent, image: IImage) => {
        if (e.button === 1) { // Middle click
            e.preventDefault();
            window.open(kuura.getContextPath() + '/api/1/image/' + image.id + '_o.jpg', '_blank');
        }
    };

    return (
        <div className="images-cluster-list" style={{ overflowX: 'hidden' }}>
            {images.map(item => (
                <div key={item.id} onClick={() => onOpen(item)} onMouseDown={(e) => handleMouseClick(e, item)} title={ImagesService.getInfoTooltip(item)}>
                    <div style={{ width: '35px', textAlign: 'center', flex: 'none' }}>
                        {item.panorama ? (
                            <span className="images-list-pano">360</span>
                        ) : (
                            <div
                                className="image-direction-arrow"
                                style={{ transform: `rotate(${item.direction}deg)` }}
                            />
                        )}
                    </div>
                    <span className="thumb-small" style={{ marginRight: '10px' }}>
                        <img
                            src={`${kuura.getContextPath()}/api/1/image/${item.id}_s.jpg`}
                            loading="lazy"
                            alt=""
                        />
                    </span>
                    <div className="flex-column" style={{ paddingRight: '30px', overflow: 'hidden' }}>
                        <strong className="ellipsis">{getFilenameWithVersion(item)}</strong>
                        <span>{utils.formatDate(item.timestamp || item.originalDate)}</span>
                        <div className="ellipsis" title={item.description}>
                            {item.description}
                        </div>
                    </div>
                    {(kuura.hasPrivilege('IMAGE_PAGE') && onEdit) && (
                        <button
                            onClick={e => {
                                e.stopPropagation();
                                onEdit(item);
                            }}
                            className="right ik-button-small ik-button-secondary--subtle"
                            style={{ position: 'absolute', right: '5px' }}
                        >
                            <i className="iki iki-edit" />
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};
